export type SpreadLayoutKey =
  | "auto"
  | "single"
  | "linear"
  | "cross-choice"
  | "choice-path"
  | "celtic-cross"
  | "psychological-circle"
  | "relationships"
  | "cycle"
  | "timeline"
  | "yearly"
  | "tree-of-life";

const SPREAD_LAYOUTS: Record<
  string,
  SpreadLayoutKey
> = {
  spread_one_card: "single",

  spread_two_cards: "linear",
  spread_3_cards: "linear",
  spread_situation_potential: "linear",
  spread_situation_development: "linear",

  spread_cross_choice: "cross-choice",
  spread_choice_path: "choice-path",
  spread_celtic_cross: "celtic-cross",
  spread_psychological_circle:
    "psychological-circle",
  spread_relationships: "relationships",
  spread_periodic_forecast: "cycle",

  spread_psychological_life_profile:
    "timeline",
  spread_yearly: "yearly",

  spread_tree_of_life: "tree-of-life",
};

export const getSpreadLayoutKey = (
  spreadId: string
): SpreadLayoutKey =>
  SPREAD_LAYOUTS[spreadId] ?? "auto";


